module.exports = __webpack_public_path__ + "img/ent-scan.96240617.png";